// import React, { useEffect, useState } from 'react';
// import { useAuth } from '../context/AuthContext';
// import { useNavigate } from 'react-router-dom';
// import { protectedAPI } from '../services/api';
// import '../styles/Dashboard.css'; // Import CSS

// const Dashboard = () => {
//   const { user, logout, loading } = useAuth();
//   const [protectedData, setProtectedData] = useState(null);
//   const [dataLoading, setDataLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     // console.log('Dashboard loaded with user:', user);
//   }, [user]);

//   const fetchProtectedData = async () => {
//     setDataLoading(true);
//     try {
//       const response = await protectedAPI.getProtectedData();
//       setProtectedData(response.data);
//     } catch (error) {
//       console.error('Error fetching protected data:', error);
//       alert('Error fetching data');
//     } finally {
//       setDataLoading(false);
//     }
//   };

//   const handleLogout = async () => {
//     if (window.confirm('Are you sure you want to logout?')) {
//       await logout();
//       navigate('/login');
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loader"></div>
//         <p>Loading dashboard...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard-container">
//       {/* Header */}
//       <div className="dashboard-header">
//         <h1 className="dashboard-title">🎯 User Dashboard</h1>
//         <button onClick={handleLogout} className="logout-button">
//           🚪 Logout
//         </button>
//       </div>

//       {/* User Profile Card */}
//       {user && (
//         <div className="user-card">
//           <img 
//             src={user.picture || 'https://via.placeholder.com/100'} 
//             alt={user.name} 
//             className="user-avatar"
//           />
//           <div>
//             <h2 className="user-name">Welcome, {user.name}! 👋</h2>
//             <p className="user-email">📧 {user.email}</p>
//             <span className="user-role">
//               {user.role === 'admin' ? '👑 Admin' : '👤 User'}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Quick Actions */}
//       <div className="dashboard-section">
//         <h3 className="section-title">⚡ Quick Actions</h3>
//         <div className="actions-grid">
//           <button onClick={() => navigate('/allquizes')} className="action-button">
//             📝 All Quizzes
//           </button>
//           <button onClick={() => navigate('/articles')} className="action-button">
//             📰 Articles
//           </button>
//           <button onClick={() => navigate('/ebooks')} className="action-button">
//             📚 E-Books
//           </button>
//           <button onClick={() => navigate('/premium')} className="action-button">
//             ⭐ Premium
//           </button>
//           <button onClick={() => navigate('/latest-updates')} className="action-button">
//             🔔 Latest Updates
//           </button>
//           <button onClick={() => navigate('/contact-us')} className="action-button">
//             📞 Contact Us
//           </button>
//         </div>
//       </div>

//       {/* User Stats */}
//       <div className="dashboard-section">
//         <h3 className="section-title">📊 Your Stats</h3>
//         <div className="stats-grid">
//           <div className="stat-card">
//             <div className="stat-number">0</div>
//             <div className="stat-label">Quizzes Taken</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-number">0</div>
//             <div className="stat-label">Articles Read</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-number">0</div>
//             <div className="stat-label">E-Books Downloaded</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useEffect, useState, useContext } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { protectedAPI } from '../services/api';
import ResultContext from '../context/ResultContext';
import Navbar from '../components/Navbar';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const { user, logout, loading } = useAuth();
  const [protectedData, setProtectedData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();
  const { setAlertContext } = useContext(ResultContext);

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    // console.log('Dashboard loaded with user:', user);
  }, [user]);

  const showAlert = (message, status) => {
    setAlertContext({
      isActive: true,
      message: message,
      status: status
    });
    setTimeout(() => {
      setAlertContext(prevState => ({ ...prevState, isActive: false }));
    }, 2000);
  };

  const fetchProtectedData = async () => {
    setDataLoading(true);
    try {
      const response = await protectedAPI.getProtectedData();
      setProtectedData(response.data);
    } catch (error) {
      console.error('Error fetching protected data:', error);
      showAlert('Error fetching data', 'error');
    } finally {
      setDataLoading(false);
    }
  };

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await logout();
      // Also remove old admin token if exists
      localStorage.removeItem('admin-token');
      showAlert('Logout successful!', 'success');
      navigate('/login');
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  // ADMIN DASHBOARD
  if (isAdmin) {
    return (
      <div className="container">
        <Navbar />
        <br /> <br /><br /><br />
        <div className="dashboard-container">
          {/* Admin Header */}
          <div className="dashboard-header" style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107' }}>
            <h1 className="dashboard-title" style={{ color: '#856404' }}>
              👑 Admin Dashboard
            </h1>
            <button onClick={handleLogout} className="logout-button">
              🚪 Logout
            </button>
          </div>

          {/* Admin Profile Card */}
          {user && (
            <div className="user-card" style={{ border: '2px solid #ffc107' }}>
              <img 
                src={user.picture || 'https://via.placeholder.com/100'} 
                alt={user.name} 
                className="user-avatar"
                style={{ border: '3px solid gold' }}
              />
              <div>
                <h2 className="user-name">Welcome Admin, {user.name}! 👑</h2>
                <p className="user-email">📧 {user.email}</p>
                <span className="user-role" style={{ backgroundColor: '#ffc107', color: '#000' }}>
                  👑 Administrator
                </span>
              </div>
            </div>
          )}

          {/* Admin Controls */}
          <div className="dashboard-section" style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107' }}>
            <h3 className="section-title" style={{ color: '#856404' }}>
              🛠️ Admin Controls
            </h3>
            <div className="actions-grid">
              <button 
                onClick={() => navigate('/createquiz')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                ➕ Create Quiz
              </button>
              <button 
                onClick={() => navigate('/allquizesforadmin')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                📝 See All Quizzes
              </button>
              <button 
                onClick={() => navigate('/createarticle')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                📰 Create Article
              </button>
              <button 
                onClick={() => navigate('/allarticles')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                📚 All Articles
              </button>
              <button 
                onClick={() => navigate('/uploadcontent')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                📤 Upload Study Material
              </button>
              <button 
                onClick={() => navigate('/create-updates')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                🔔 Upload Latest Updates
              </button>
              <button 
                onClick={() => navigate('/create-new-batch')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                ⭐ Add Premium Batch
              </button>
              <button 
                onClick={() => navigate('/premium')} 
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                💼 All Premium Batches
              
              </button>
              <button
                onClick={() => navigate('/manage-typing')}
                className="action-button"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold' }}
              >
                ⌨️ Manage Typing
              </button>

              <button 
                onClick={() => navigate('/adminpage')} 
                className="action-button"
                style={{ backgroundColor: '#28a745', color: '#fff', fontWeight: 'bold' }}
              >
                🏠 Old Admin Page
              </button>
            </div>
          </div>

          {/* Quick Actions for Admin (User Features) */}
          <div className="dashboard-section">
            <h3 className="section-title">⚡ Quick Actions</h3>
            <div className="actions-grid">
              <button onClick={() => navigate('/allquizes')} className="action-button">
                📝 All Quizzes
              </button>
              <button onClick={() => navigate('/articles')} className="action-button">
                📰 Articles
              </button>
              <button onClick={() => navigate('/ebooks')} className="action-button">
                📚 E-Books
              </button>
              <button onClick={() => navigate('/premium')} className="action-button">
                ⭐ Premium
              </button>
              <button onClick={() => navigate('/latest-updates')} className="action-button">
                🔔 Latest Updates
              </button>
              <button onClick={() => navigate('/contact-us')} className="action-button">
                📞 Contact Us
              </button>
            </div>
          </div>

          {/* Admin Stats */}
          <div className="dashboard-section">
            <h3 className="section-title">📊 Platform Stats</h3>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">0</div>
                <div className="stat-label">Total Users</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">0</div>
                <div className="stat-label">Total Quizzes</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">0</div>
                <div className="stat-label">Total Articles</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // REGULAR USER DASHBOARD
  return (
    <div className="container">
      <Navbar />
      <div className="dashboard-container">
        {/* Header */}
        <div className="dashboard-header">
          <h1 className="dashboard-title">🎯 User Dashboard</h1>
          <button onClick={handleLogout} className="logout-button">
            🚪 Logout
          </button>
        </div>

        {/* User Profile Card */}
        {user && (
          <div className="user-card">
            <img 
              src={user.picture || 'https://via.placeholder.com/100'} 
              alt={user.name} 
              className="user-avatar"
            />
            <div>
              <h2 className="user-name">Welcome, {user.name}! 👋</h2>
              <p className="user-email">📧 {user.email}</p>
              <span className="user-role">
                👤 User
              </span>
            </div>
          </div>
        )}

        {/* Quick Actions */}
        <div className="dashboard-section">
          <h3 className="section-title">⚡ Quick Actions</h3>
          <div className="actions-grid">
            <button onClick={() => navigate('/allquizes')} className="action-button">
              📝 All Quizzes
            </button>
            <button onClick={() => navigate('/articles')} className="action-button">
              📰 Articles
            </button>
            <button onClick={() => navigate('/ebooks')} className="action-button">
              📚 E-Books
            </button>
            <button onClick={() => navigate('/premium')} className="action-button">
              ⭐ Premium
            </button>
            <button onClick={() => navigate('/latest-updates')} className="action-button">
              🔔 Latest Updates
            </button>
            <button onClick={() => navigate('/contact-us')} className="action-button">
              📞 Contact Us
            </button>
          </div>
        </div>

        {/* User Stats */}
        <div className="dashboard-section">
          <h3 className="section-title">📊 Your Stats</h3>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">0</div>
              <div className="stat-label">Quizzes Taken</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">0</div>
              <div className="stat-label">Articles Read</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">0</div>
              <div className="stat-label">E-Books Downloaded</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;